import React from 'react';
import { Star } from 'lucide-react';
const reviews = [{
  text: 'Das Futtertopping Magen & Darm ist echt richtig gut. Unser Golden Retriever ist viel besser drauf. Ein absolut empfehlenswertes Produkt.',
  author: 'Familie Berger & Ben'
}, {
  text: 'Seit wir das Topping regelmäßig geben, geht es unserem Labrador viel viel besser. Macht weiter so!',
  author: 'Familie Weber & Charlie'
}, {
  text: 'Nala hat das Futtertopping sehr gut vertragen – gerne bestelle ich es wieder. Klasse!',
  author: 'Petra aus Köln'
}];
export function Testimonials() {
  return <section className="px-4 mb-12" data-id="element-84">
      <h3 className="font-handwriting text-3xl font-bold text-center text-forest mb-8" data-id="element-85">
        Was andere Hundebesitzer sagen
      </h3>

      <div className="space-y-4" data-id="element-86">
        {reviews.map((review, index) => <div key={index} className="bg-card p-6 rounded-xl shadow-sm border border-brown/5" data-id="element-87">
            <div className="flex gap-1 mb-3" data-id="element-88">
              {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-brown text-brown" data-id="element-89" />)}
            </div>
            <p className="font-serif text-text/90 italic mb-4" data-id="element-90">
              "{review.text}"
            </p>
            <p className="font-serif text-sm font-bold text-forest" data-id="element-91">
              – {review.author}
            </p>
          </div>)}
      </div>
    </section>;
}